export class FurnacePowerFailure {
  constructor({
    id = ``,
    date = ``,
    locName = ``,
    locId = ``,
    shiftName = ``,
    furnaceNumber = ``,
    stopNumber = ``,
    stopTime = ``,
    startTime = ``,
    totalStop = ``,
    stopReason = ``,
  } = {}) {
    this.id = id;
    this.date = date;
    this.locName = locName;
    this.locId = locId;
    this.shiftName = shiftName;
    this.furnaceNumber = furnaceNumber;
    this.stopNumber = stopNumber;
    this.stopTime = stopTime;
    this.startTime = startTime;
    this.totalStop = totalStop;
    this.stopReason = stopReason;
  }
}

export function gridFields() {
  return Object.freeze([
    {
      key: 'date',
      label: 'lbl.basic.date',
      sortable: true,
      form: {
        type: 'datepicker'
      }
    },
    {
      key: 'locName',
      label: 'lbl.fm.locationName',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'shiftName',
      label: 'lbl.basic.shift',
      sortable: true,
      default: 'default',
      form: {
        type: 'select',
        options: [
          { value: "default", text: "lbl.basic.select.one" },
          { value: "甲", text: "lbl.shift.A" },
          { value: "乙", text: "lbl.shift.B" },
          { value: "丙", text: "lbl.shift.C" }
        ]
      }
    },
    {
      key: 'furnaceNumber',
      label: 'lbl.basic.furnaceName',
      sortable: true,
      default: 'default',
      form: {
        type: 'select',
        options: [
          { value: "default", text: "lbl.basic.select.one" },
          { value: "1", text: "opt.furnaceNumber1" },
          { value: "2", text: "opt.furnaceNumber2" },
          { value: "3", text: "opt.furnaceNumber3" },
          { value: "4", text: "opt.furnaceNumber4" },
          { value: "5", text: "opt.furnaceNumber5" },
          { value: "6", text: "opt.furnaceNumber6" }
        ]
      }
    },
    {
      key: 'stopNumber',
      label: 'lbl.sop.stopNumber',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'stopTime',
      label: 'lbl.sop.stopTime',
      sortable: true,
      form: {
        type: 'timepicker'
      }
    },
    {
      key: 'startTime',
      label: 'lbl.sop.startTime',
      sortable: true,
      form: {
        type: 'timepicker'
      }
    },
    {
      key: 'totalStop',
      label: 'lbl.sop.totalStop',
      sortable: true,
      form: {
        type: 'input'
      }
    },
    {
      key: 'stopReason',
      label: 'lbl.sop.stopReason',
      sortable: true,
      form: {
        type: 'input'
      }
    }
  ]);
}

export const fields = Object.freeze(Object.keys(new FurnacePowerFailure()).map(i => 'entity.' + i));

export const filterFields = [
  'filter.startTimeFilter',
  'filter.endTimeFilter',
  'filter.shiftNameFilter',
  'filter.furnaceNumberFilter',
  'filter.stopNumberFilter',
  'filter.locNameFilter',
];

export const filter = {
  'startTimeFilter': "",
  'endTimeFilter': "",
  'shiftNameFilter': "default",
  'furnaceNumberFilter': "default",
  'stopNumberFilter': "",
  'locNameFilter': "default",
};